import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { fetchContactus } from '../actions';
import Helmet from '../components/Helmet';
import { makeStyles, useTheme, withStyles } from '@material-ui/core/styles';
import useDeepCompareEffect from 'use-deep-compare-effect'
import PageCover from '../components/PageCover';
import LogoBanner from '../components/LogoBanner';
import { Typography, Container, TextField, Select, FormControl, MenuItem, InputLabel, InputBase, Button } from '@material-ui/core';
import service from '../services/emailService';
import config from '../../helpers/config';

const useStyles = makeStyles(theme => ({

    container: {
        '& hr': {
            margin: '50px 10%',
            [theme.breakpoints.down("xs")]: {
                margin: '20px 0',
            }
        },
        '& .desc': {
            paddingBottom: 60,
            '& h3': {
                letterSpacing: '20px',
                [theme.breakpoints.down("xs")]: {
                    letterSpacing: '7px',
                    padding: '0px 15px'
                }
            }
        }
    },
    bannerLogo: props => ({
        backgroundImage: props.bannerContentImgUrl ?'url(' + config.S3Endpoint + props.bannerContentImgUrl + ')' : '',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '85%',
        backgroundPosition: 'center',
        margin: '0 auto',
        height: '300px',
        width: '300px', 
        
        [theme.breakpoints.down("xs")]: {
            height: '150px',
            width: '150px'
        },
    }),

    TextFieldRoot: {
        marginBottom: '20px',
    },

    InputRoot: {
        backgroundColor: '#f7eaf3',
        borderRadius: '25px',
        boxShadow: '2px 4px 2px rgba(0,0,0,0.1)',
    },

    submit: {
        border: '1px solid ' + theme.palette.primary.main,
        padding: '5px 150px',
        marginTop: 20,

        [theme.breakpoints.down("sm")]: {
            padding: '5px',
            width: '100%'
        }
    },

    location: {
        color: theme.palette.primary.dark,
        textAlign: 'center',
        paddingBottom: 50,
        [theme.breakpoints.down("xs")]: {
            paddingBottom: 20,
        }
    },

    map: {
        margin: '0 auto',
        width: '100%',
        height: 500,
        textAlign: 'center',
        display: 'table',
        borderRadius: '25px',
        boxShadow: 'none',
        border: '5px solid pink'
    },
}));

const Form = (props) => {
    const classes = useStyles(props);
    const contentRef = props.contentRef;
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [address, setAddress] = useState("");
    const [dueDate, setDueDate] = useState(0);
    const [appointmentDate, setAppointmentDate] = useState(0);
    const [appointmentTime, setAppointmentTime] = useState(0);
    const [duration, setDuration] = useState(0);
    const [callbackTime, setCallbackTime] = useState(0);
    const [reference, setReference] = useState(0);
    const [note, setNote] = useState("");
    const [submitValidate, setSubmitValidate] = useState(false);
    const [hasSubmitted, setHasSubmitted] = useState(false);

    useEffect(() => {
        if (!!name && !!phone && !!address && !!dueDate && !!appointmentDate && !!appointmentTime && !!duration && !!callbackTime && !!reference) {
            if (appointmentTime === 5) {
                setSubmitValidate(!!note);
            } else {
                setSubmitValidate(true)
            }
        }
    }, [name, phone, address, dueDate, appointmentDate, appointmentTime, duration, callbackTime, reference, note]);

    
    const onNameChange = (e) => setName(e.target.value);
    const onPhoneChange = (e) => setPhone(e.target.value);
    const onAddressChange = (e) => setAddress(e.target.value);
    const onDueDateChange = (e) => setDueDate(e.target.value);
    const onAppointmentDateChange = (e) => setAppointmentDate(e.target.value);
    const onAppointmentTimeChange = (e) => setAppointmentTime(e.target.value);
    const onDurationChange = (e) => setDuration(e.target.value);
    const onCallbackTimeChange = (e) => setCallbackTime(e.target.value);
    const onReferenceChange = (e) => setReference(e.target.value);
    const onNoteChange = (e) => setNote(e.target.value);

    const handleSubmit = async (e) => {
        setHasSubmitted(true);
        if (submitValidate) {
            try {
                await service.emailToMibao({
                    name,
                    phone,
                    address,
                    dueDate: new Date(dueDate).toLocaleDateString('zh'),
                    appointmentDate: new Date(appointmentDate).toLocaleDateString('zh'),
                    appointmentTime: props.appointmentTimeOption[appointmentTime].desc,
                    duration: props.durationOption[duration].desc,
                    callbackTime: props.callbackOption[callbackTime].desc,
                    reference: props.referenceOption[reference].desc,
                    note
                });
            } catch (error) {
                console.log(error);
            }
        } else {
            contentRef.current.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
        }
    }

    const textFiledPorps = {
        margin: 'dense',
        fullWidth: true,
        required: true,
        classes: { root: classes.TextFieldRoot },
        variant: "outlined",
        InputProps: {
            classes: {
                root: classes.InputRoot
            }
        },
        InputLabelProps: {
            shrink: true
        }
    };

    /**
     * validation
     */
    const nameVal = hasSubmitted && name === '';
    const phoneVal = hasSubmitted && phone === '';
    const addressVal = hasSubmitted && address === '';
    const dueDateVal = hasSubmitted && new Date(dueDate) < new Date();
    const appointmentDateVal = hasSubmitted && new Date(appointmentDate) < new Date();
    const appointmentTimeVal = hasSubmitted && appointmentTime === 0;
    const durationVal = hasSubmitted && duration === 0;
    const callbackTimeVal = hasSubmitted && callbackTime === 0;
    const referenceVal = hasSubmitted && reference === 0;
    const noteVal = hasSubmitted && appointmentTime === 5 && note === '';

    /**
     * helper text
     */
    const nameWarnTxt = nameVal && '請輸入姓名';
    const phoneWarnTxt = phoneVal && '請輸入電話';
    const addressWarnTxt = addressVal && '請輸入地址';
    const dueDateWarnTxt = dueDateVal && '請選擇有效日期';
    const appointmentDateWarnTxt = appointmentDateVal && '請選擇有效日期';
    const appointmentTimeWarnTxt = appointmentTimeVal && '請選擇時間';
    const durationWarnTxt = durationVal && '請選擇入住天數';
    const callbackTimeWarnTxt = callbackTimeVal && '請選擇回撥時段';
    const referenceWarnTxt = referenceVal && '請選擇取得資訊';
    const noteWarnTxt = noteVal && '請註明參觀時段';

    return (
        <form noValidate onSubmit={handleSubmit} >
            <TextField id="name" label="姓名" onChange={onNameChange} error={nameVal} helperText={nameWarnTxt} {...textFiledPorps} />
            <TextField id="phone" label="電話" onChange={onPhoneChange} error={phoneVal} helperText={phoneWarnTxt} {...textFiledPorps} />
            <TextField id="address" label="地址" onChange={onAddressChange} error={addressVal} helperText={addressWarnTxt} {...textFiledPorps} />
            <TextField id="dueDate" label="預產期" onChange={onDueDateChange} type="date" error={dueDateVal} helperText={dueDateWarnTxt} {...textFiledPorps} />
            {/* <TextField id="appointmentDate" label="參觀日期" onChange={onAppointmentDateChange} type="date" error={appointmentDateVal} helperText={appointmentDateWarnTxt} {...textFiledPorps} />
            <TextField id="appointmentTime" label="參觀時段" onChange={onAppointmentTimeChange} select error={appointmentTimeVal} helperText={appointmentTimeWarnTxt} {...textFiledPorps}>
                {props.appointmentTimeOption.map((d, i) =>
                   <MenuItem key={i} value={d.id}>{d.desc}</MenuItem>
                )}
            </TextField> */}
            <TextField id="duration" label="預計入住天數" onChange={onDurationChange} select error={durationVal} helperText={durationWarnTxt} {...textFiledPorps}>
                {props.durationOption.map((d, i) => 
                   <MenuItem key={i} value={d.id}>{d.desc}</MenuItem>
                )}
            </TextField>
            <TextField id="callbackTime" label="致電時間" onChange={onCallbackTimeChange} select error={callbackTimeVal} helperText={callbackTimeWarnTxt} {...textFiledPorps}>
                {props.callbackOption.map((d, i) => 
                   <MenuItem key={i} value={d.id}>{d.desc}</MenuItem>
                )}
            </TextField>
            <TextField id="reference" label="取得資訊" onChange={onReferenceChange} select error={referenceVal} helperText={referenceWarnTxt} {...textFiledPorps}>
                {props.referenceOption.map((d, i) => 
                   <MenuItem key={i} value={d.id}>{d.desc}</MenuItem>
                )}
            </TextField>
            <TextField id="note" label="備註" onChange={onNoteChange} multiline rows={10} error={noteVal} helperText={noteWarnTxt} {...textFiledPorps} />

            <div style={{width: '100%', textAlign: 'center'}}>
                <Button onClick={handleSubmit} className={classes.submit}>
                    <Typography variant="h4"><b>提交</b></Typography>
                </Button>
            </div>
           
        </form>
    )
}

const ContactusPage = (props) => {

    const theme = useTheme();
    const { contactus } = props;
    const classes = useStyles(contactus);
    const contentRef = useRef(null);
    
    useDeepCompareEffect(() => {
        if (!contactus.isLoaded) props.fetchContactus();
    }, [contactus])

    if (!contactus.isLoaded) {
        return <div>Loading...</div>;
    }



    const PageCoverProps = {
        ...contactus,
        skipScroll: true,
        style: {
            height: 'calc(100vh - 75px)',
            title: {
                position: 'absolute',
                top: 'auto',
                right: '0',
                bottom: '10%',
                left: 'auto',
                width: '33%',
                letterSpacing: '10px',
                backgroundColor: 'rgba(255,255,255,0.1)',
                color: 'white',
                fontWeight: '500',
                padding: '20px 0px 20px 5vw',
                borderTopLeftRadius: '40px',
                borderBottomLeftRadius: '40px',
                border: '1px solid #dadada',
                textShadow: '1px 1px 4px black',
                '& h1': {
                    float: 'left',
                    fontWeight: '500'
                },
                [theme.breakpoints.down('xs')] : {
                    width: '75%',
                }
            }
        }
    };

    
    return (
        <div className={classes.container}>
            <Helmet {...contactus} />
            <PageCover {...PageCoverProps} > 
                <Typography variant="h1">{contactus.name}</Typography>
            </PageCover>

            <LogoBanner {...contactus} ratio={349 / 395} height={300}>
                <div className={classes.bannerLogo}></div>
            </LogoBanner>

            <hr></hr>

            <Container ref={contentRef} >
                <div className="desc">
                    <Typography variant="h3">{contactus.desc}</Typography>
                </div>
                <Form  {...contactus} contentRef={contentRef} />
            </Container>

            <hr></hr>

            <Container>
                <Typography variant="h2" className={classes.location}><b>{contactus.location}</b></Typography>
                <iframe className={classes.map} src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3664.2585109320667!2d120.30688421513373!3d23.30637761150943!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346e8571ea641947%3A0x41e938c5823155ec!2z5ZKq5a-255Si5b6M6K2355CG5LmL5a62!5e0!3m2!1sen!2sus!4v1580395830669!5m2!1sen!2sus"></iframe>
            </Container>

        </div>
    )
}

function mapStateToProps({ contactus }) {
    return { contactus };
}

export default {
    loadData: ({ dispatch }) => dispatch(fetchContactus()),
    component:  connect(mapStateToProps, { fetchContactus }) (ContactusPage)
}



// WEBPACK FOOTER //
// ./src/client/pages/ContactusPage.js